import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
  }

  html, body, #__next {
    min-height: 100%;
    height: 100%;
    overflow: hidden;
  }

  body {
    text-rendering: optimizelegibility !important;
    -webkit-font-smoothing: antialiased !important;
  }

  #__next {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  fieldset {
    border: none;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;

    &:disabled {
      color: unset;
    }
  }

  input {
    border: none;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  b {
    font-weight: 600;
  }
`;
